import { render } from "./TemplateReceipt.vue?vue&type=template&id=dfd24ba6&scoped=true"
import script from "./TemplateReceipt.vue?vue&type=script&lang=js"
export * from "./TemplateReceipt.vue?vue&type=script&lang=js"

import "./TemplateReceipt.vue?vue&type=style&index=0&id=dfd24ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd24ba6"]])

export default __exports__